import { ClearButton } from './components/clear-button';
import { ClearChip } from './components/clear-chip';
import { ClearIconButton } from './components/clear-icon-button';
import { ClearButtonBaseProps, ClearButtonType } from './types';

export const CLEAR_BUTTONS_REGISTRY = new Map<
  ClearButtonType,
  (props: ClearButtonBaseProps) => any
>([
  [ClearButtonType.BUTTON, ClearButton],
  [ClearButtonType.CHIP, ClearChip],
  [ClearButtonType.ICON_BUTTON, ClearIconButton],
]);
